import React from 'react';
import GeneralSettings from '../../Administration/GeneralSettings';

export default function GeneralSettingsPage() {
  return (
    <>
      <GeneralSettings />
    </>
  );
}
